// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__ts9tk","footerWrapper":"footer_footerWrapper__I1TZ7","footerContainer":"footer_footerContainer__DL9f3","logo":"footer_logo__2BxHP"};